/* Pinned Add to cart bar for phones.
   ==========================================================================
   THE BUG THIS FIXES
   On a phone the 3D stage is sticky (see builder-mobile.css section 1) so the
   model stays visible while you scroll the options. Sticky elements paint over
   the content that scrolls beneath them, and the stage carries z-index 3 - so
   once the real Add to cart button scrolls up past the bottom edge of the
   pinned stage, it is still VISIBLE as a white sliver but no longer hittable.
   Taps land on the WebGL canvas and rotate the bike instead.

   Measured on a 375x812 viewport: the button was only tappable between scrollY
   1120 and 1400 out of 2106. Scroll to the bottom of the page to read the rest
   of the build - the natural thing to do - and the one button that takes money
   silently stops working.

   THE FIX
   A fixed bar across the bottom of the viewport, above the stage in the
   stacking order, carrying the running total and a button that forwards its
   click to the real one. Nothing here reimplements adding to cart: it calls
   real.click(), so the section's own handler runs and cart-builds.js still
   stamps the build id exactly as before. If this script fails, the page is
   what it was.

   It also mirrors the real button's label and disabled state, because the
   section rewrites that text through the add ("Adding..." / "Added!") and a
   bar that kept saying "Add to cart" through all of it would read as broken.
   ========================================================================== */
(function builderBuyBar() {
  var PHONE = '(max-width: 900px)';

  function init() {
    var section = document.getElementById('pm-3d');
    if (!section) return;

    var real = section.querySelector('.pm-addcart');
    if (!real) return;
    if (document.querySelector('.pm-buybar')) return;

    var bar = document.createElement('div');
    bar.className = 'pm-buybar';

    var price = document.createElement('span');
    price.className = 'pm-buybar__price';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pm-buybar__btn';

    bar.appendChild(price);
    bar.appendChild(btn);
    document.body.appendChild(bar);

    /* The running total the receipt already maintains - don't recompute it,
       just mirror it. */
    var priceSource = document.getElementById('pm-price')
      || section.querySelector('.pm-builder-price');

    function sync() {
      if (priceSource) price.textContent = (priceSource.textContent || '').trim();
      var label = (real.textContent || '').trim();
      btn.textContent = label || 'Add to cart';
      btn.disabled = !!real.disabled;
    }

    sync();

    if (window.MutationObserver) {
      var watch = new MutationObserver(sync);
      if (priceSource) {
        watch.observe(priceSource, { childList: true, characterData: true, subtree: true });
      }
      watch.observe(real, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }

    /* Forward, don't reimplement. */
    btn.addEventListener('click', function () {
      real.click();
    });

    /* Only while the builder is actually on screen - the bar has no business
       hovering over the spec strip or the footer.

       Deliberately keyed to the SECTION being visible, not to the real button
       being off screen: the real button can be "visible" per IntersectionObserver
       while sitting underneath the sticky stage and taking no taps, which is the
       exact failure this bar exists to cover. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(
        function (entries) {
          var on = entries[0].isIntersecting && window.matchMedia(PHONE).matches;
          bar.classList.toggle('is-shown', on);
        },
        { threshold: 0 }
      ).observe(section);
    } else {
      bar.classList.add('is-shown');
    }

    window.__pmBuyBar = { el: bar, sync: sync };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();